import hiClient from "../axios/hiClient";
import { useFetch } from "../hooks/useFetch";
import { DeviceDetailCard } from "./DeviceDetailCard";
import { PieChartCard } from "./PieChartCard";
import primeClient from "../axios/primeClient";
import { timeAgo } from "../utils/timeAgo";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { parseDateISO8601 } from "../utils/parseDate";

export const Alarms = () => {
  const loginType = localStorage.getItem("login_type");

  if (!loginType) return null;

  return (
    <div
      style={{
        padding: "2rem 1rem 0 1rem",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
        overflowY: "auto",
      }}
    >
      <div
        style={{
          flexGrow: "1",
          display: "grid",
          gridTemplateRows: "4fr 5.5fr",
          gap: "1rem",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              fontSize: "1.25rem",
              marginBottom: "0.5rem",
              fontWeight: "bold",
            }}
          >
            {t("prime.alarm.header")}
          </div>
          <PieChartCard />
        </div>
        {loginType === "prime" ? (
          <PrimeDeviceCardGroup />
        ) : (
          <HiDeviceCardGroup />
        )}
      </div>
    </div>
  );
};

const PrimeDeviceCardGroup = () => {
  const isMobile = window.innerWidth <= 570;
  const { t } = useTranslation();
  const { data: alarmData } = useFetch({
    url: "/v1/apps/alarm",
    client: primeClient,
    initialData: { alarms: [] },
  });

  const dataMapper = (el) => ({
    id: el.id,
    name: el.data.name,
    identifier: el.data.ip_address,
    lastUpdated: el.updated_at ? timeAgo(el.updated_at, t) : "unknown",
    description: [],
    alarmType: el.alarm_type,
    last_updated: el.updated_at,
  });
  // last_updated is like "2024-10-17 09:08:01.916147"

  const sortByLastUpdated = [...alarmData.alarms].sort((a, b) => {
    return parseDateISO8601(b.updated_at) - parseDateISO8601(a.updated_at);
  });

  console.log(sortByLastUpdated);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: !isMobile
          ? "repeat(2, 1fr)"
          : "repeat(auto-fill, minmax(300px, 1fr))",
        justifyContent: "space-between",
        gap: "1rem",
      }}
    >
      <DeviceDetailCard
        headerText={"Unread"}
        loginType={"prime"}
        data={sortByLastUpdated.filter((el) => !el.is_read).map(dataMapper)}
      />
      <DeviceDetailCard
        headerText={"Read"}
        loginType={"prime"}
        data={sortByLastUpdated.filter((el) => el.is_read).map(dataMapper)}
      />
    </div>
  );
};

const HiDeviceCardGroup = () => {
  const isMobile = window.innerWidth <= 570;
  const { t } = useTranslation();
  const { data: alarmData } = useFetch({
    url: "/alarm/list",
    client: hiClient,
    initialData: { alarms: [] },
  });

  const dataMapper = (el) => ({
    name: el.data.name,
    identifier: el.data.ip_address,
    lastUpdated: el.updated_at ? timeAgo(el.updated_at, t) : "unknown",
    description: [],
    alarmType: el.alarm_type,
    last_updated: el.updated_at,
  });

  const sortByLastUpdated = [...alarmData.alarms].sort((a, b) => {
    return parseDateISO8601(b.updated_at) - parseDateISO8601(a.updated_at);
  });

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: !isMobile
          ? "repeat(2, 1fr)"
          : "repeat(auto-fill, minmax(300px, 1fr))",
        justifyContent: "space-between",
        gap: "1rem",
      }}
    >
      <DeviceDetailCard
        headerText={"Unread"}
        loginType={"hi"}
        data={alarmData.alarms.filter((el) => !el.is_read).map(dataMapper)}
      />
      <DeviceDetailCard
        headerText={"Read"}
        loginType={"hi"}
        data={alarmData.alarms.filter((el) => el.is_read).map(dataMapper)}
      />
      {isMobile && (
        <div
          style={{
            height: "50px",
          }}
        />
      )}
    </div>
  );
};
